import React from "react";
import { Box } from "@material-ui/core";

const UnauthorizedAccess = () => (
  <Box
    style={{
      textAlign: "center",
      height: "80vh",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
    }}
  >
    <h1>Unauthorized</h1>
    <p>You are not authorized to view this page</p>
  </Box>
);

export default UnauthorizedAccess;
